import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (req.url.includes('/logout')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error) => {
      console.log('Error ==> ', error);
      if (error.status === 401) {
        authService.handleLogout(true);
      } else if (error.status === 403) {
        setTimeout(() => router.navigate(['/error/403']), 100);
      } else if (error.status >= 500) {
        console.error('Error del servidor:', error.message);
        alert('Ocurrió un error en el servidor. Intenta más tarde.');
      }
      return throwError(() => error);
    })
  );
};
